import { faqItems } from '@/mocks/home';

export default function FaqSection() {
  return (
    <section id="faq" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950">
            常见问题
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            关于汗汗漫画的使用与功能，这里有你想要的答案
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {faqItems.map((item) => (
            <div
              key={item.id}
              className="bg-background-100 rounded-xl border border-background-200/60 overflow-hidden"
            >
              <div className="px-5 md:px-6 py-4 md:py-5 flex items-start gap-4">
                <div className="w-7 h-7 rounded-full bg-primary-100/70 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <span className="text-primary-600 font-semibold text-xs">Q</span>
                </div>
                <div className="flex-1">
                  <h3 className="font-semibold text-sm md:text-base text-foreground-950">
                    {item.question}
                  </h3>
                  <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
                    {item.answer}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}